import React, { useEffect } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { TabView, TabPanel } from 'primereact/tabview';
import { Calendar } from 'primereact/calendar';

const Cookies = ({ cookies, productProperties, editable, employees, removeCookies, handleCookiesChange }) => {

  const handleDropdownChange = (e, index, key) => {
    const newCookies = [...cookies];
    newCookies[index] = { ...newCookies[index], [key]: e.value };
    handleCookiesChange(index, newCookies[index]);
  };

  const handleInputChange = (event, index, key) => {
    const value = event.target.value;
    const newCookies = [...cookies];
    newCookies[index] = { ...newCookies[index], [key]: value };
    handleCookiesChange(index, newCookies[index]);
  };

  const actionTemplate = (rowData, column) => {
    return <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => removeCookies(column.rowIndex)} />;
  };

  const getEmployeesByRole = (role) => {
    return employees.filter(employee => employee.roles.includes(role)).map(employee => ({ label: employee.name, value: employee.name }));
  };

  const flavorOptions = [{ label: 'None', value: null }, ...productProperties[0]?.flavors.cookies.map(cookie => ({ label: cookie, value: cookie }))];
  const icingOptions = [{ label: 'None', value: null }, ...productProperties[0]?.flavors.decoratingIcings.map(icing => ({ label: icing, value: icing }))];

  return (
 
      <DataTable value={cookies} size="small" editMode="cell">
        {editable || cookies.some(cookie => cookie.quantity) ? (
        <Column field="quantity" header="Quantity" editor={editable ? (props) =>
          <InputText value={cookies[props.rowIndex]?.quantity} onChange={(e) => handleInputChange(e, props.rowIndex, 'quantity')} />
          : null} />
        ) : null}
        {editable || cookies.some(cookie => cookie.flavor) ? (
        <Column field="flavor" header="Flavor" editor={editable ? (props) =>
          <Dropdown value={props.rowData['flavor']} filter 
          options={flavorOptions}
          onChange={(e) => handleDropdownChange(e, props.rowIndex, 'flavor')} />
          : null} />
        ) : null}
        {editable || cookies.some(cookie => cookie.shape) ? (
        <Column field="shape" header="Shape" editor={editable ? (props) =>
          <InputText value={cookies[props.rowIndex]?.shape} onChange={(e) => handleInputChange(e, props.rowIndex, 'shape')} />
          : null} />
        ) : null}

        {editable || cookies.some(cookie => cookie.description) ? (
        <Column field="description" header="Description" editor={editable ? (props) =>
          <InputText value={cookies[props.rowIndex]?.description} onChange={(e) => handleInputChange(e, props.rowIndex, 'description')} />
          : null} />
        ) : null}
        {editable || cookies.some(cookie => cookie.icing) ? (
        <Column field="icing" header="Icing" editor={editable ? (props) =>
          <Dropdown value={props.rowData['icing']} filter 
          options={icingOptions}
          onChange={(e) => handleDropdownChange(e, props.rowIndex, 'icing')} />
          : null} />
        ) : null}
        {editable || cookies.some(cookie => cookie.icingColor) ? (
        <Column field="icingColor" header="Icing Color" editor={editable ? (props) =>
          <InputText value={cookies[props.rowIndex]?.icingColor} onChange={(e) => handleInputChange(e, props.rowIndex, 'icingColor')} />
          : null} />
        ) : null}
        {editable || cookies.some(cookie => cookie.decoratingNotes) ? (
        <Column field="decoratingNotes" header="Decorating Notes" editor={editable ? (props) =>
          <InputText value={cookies[props.rowIndex]?.decoratingNotes} onChange={(e) => handleInputChange(e, props.rowIndex, 'decoratingNotes')} />
          : null} />
        ) : null}
        {editable || cookies.some(cookie => cookie.price) ? (
        <Column field="price" header="Price" editor={editable ? (props) =>
          <InputText value={cookies[props.rowIndex]?.price} onChange={(e) => handleInputChange(e, props.rowIndex, 'price')} />
          : null} />
        ) : null}
        {editable && <Column body={actionTemplate} style={{ textAlign: 'center', width: '8em' }} />}
      </DataTable>



    // </Card>
  );
};

export default Cookies;

